module.exports = __webpack_public_path__ + "static/media/pbbg.7491b6f9.jpg";